import { DiscriminationOfAllSubjectsPage } from './DiscriminationOfAllSubjectsPage';
export default DiscriminationOfAllSubjectsPage;
